export default __webpack_public_path__ + "static/icon-6-1-c1efce6ef23cc60687e18ed5cad0cedc.png";